module.exports = {"361121001":"旭日街道","361121002":"罗桥街道","361121003":"兴园街道","361121101":"田墩镇","361121102":"上泸镇","361121103":"华坛山镇","361121104":"茶亭镇","361121105":"皂头镇","361121106":"四十八镇","361121107":"枫岭头镇","361121108":"煌固镇","361121109":"花厅镇","361121110":"五府山镇","361121111":"郑坊镇","361121200":"望仙乡","361121201":"石人乡","361121202":"清水乡","361121203":"石狮乡","361121204":"湖村乡","361121207":"尊桥乡","361121209":"应家乡","361121210":"黄沙岭乡","361121211":"铁山乡","361121290":"董团乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361121.json
// module id = 1456
// module chunks = 0